module.exports = __webpack_public_path__ + "img/sh_home.fcca7084.png";